import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-partners',
  templateUrl: './our-partners.component.html',
  styleUrls: ['./our-partners.component.css'],
})
export class OurPartnersComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
